import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const Battery30FilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path fillRule="evenodd" d="M18.3603 7.0998H14.7603V5.2998H18.3603V7.0998Z" />
      <path fillRule="evenodd" d="M9.24014 7.0998H5.64014V5.2998H9.24014V7.0998Z" />
      <path
        fillRule="evenodd"
        d="M18.0001 10.0402H6.0001C5.66873 10.0402 5.4001 10.3089 5.4001 10.6402V15.4402C5.4001 15.7716 5.66873 16.0402 6.0001 16.0402H18.0001C18.3315 16.0402 18.6001 15.7716 18.6001 15.4402V10.6402C18.6001 10.3089 18.3315 10.0402 18.0001 10.0402ZM6.0001 8.24023C4.67461 8.24023 3.6001 9.31475 3.6001 10.6402V15.4402C3.6001 16.7657 4.67462 17.8402 6.0001 17.8402H18.0001C19.3256 17.8402 20.4001 16.7657 20.4001 15.4402V10.6402C20.4001 9.31475 19.3256 8.24023 18.0001 8.24023H6.0001Z"
      />
      <path d="M6.6001 11.6002C6.6001 11.4014 6.77417 11.2402 6.9889 11.2402H9.8401V14.8402H6.9889C6.77417 14.8402 6.6001 14.6791 6.6001 14.4802V11.6002Z" />
    </SvgIcon>
  );
});
